export default (diet, ingredients) =>
  diet
    .filter(ingredient => ingredient.hasOwnProperty.call(ingredient, 'title'))
    .map(ingredient => {
      const { title, efValue } = ingredient.title
        ? ingredients.find(i => ingredient.title === i.title)
        : false;

      return {
        title,
        efValue,
        ...ingredient,
      };
    });
